import { Link, LinkOwnProps } from 'evergreen-ui';

import { SelectedReferral } from '../../domain/selectedReferral';
import { SiblingReferral } from '../../domain/types';
import { useApplicationRootUrl } from 'common/component/ApplicationRootContext';

type Props = {
    siblingReferral: SiblingReferral;
    toOfferForm?: boolean;
} & LinkOwnProps;

export function SiblingReferralLink({ siblingReferral, toOfferForm = false, ...linkProps }: Props) {
    const referralGuid = siblingReferral.siblingReferralGuid;
    const rootUrl = useApplicationRootUrl();
    const href = toOfferForm ? SelectedReferral.createReferralNewOfferLink(referralGuid, rootUrl) : SelectedReferral.createSelectedReferralLink(referralGuid, rootUrl);
    return (
        <Link target="_blank" rel="noopener" href={ href } { ...linkProps }>
            <span className="text-blue-portal-link">{ siblingReferral.siblingCaseNumber }</span>
        </Link>
    );
}
